import { defineMessages } from 'react-intl';

export default defineMessages({
	linkText: {
		id: 'app.ui.scenesLink',
		defaultMessage: 'Scenes',
		description: 'The title of the scenes selection page',
	},
});
